import { render, staticRenderFns } from "./global-guide-iframe.vue?vue&type=template&id=6f200c6c&scoped=true&"
import script from "./global-guide-iframe.vue?vue&type=script&lang=js&"
export * from "./global-guide-iframe.vue?vue&type=script&lang=js&"
import style0 from "./global-guide-iframe.vue?vue&type=style&index=0&id=6f200c6c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f200c6c",
  null
  
)

export default component.exports